export default __webpack_public_path__ + "static/media/schedule-4.2a6f6609.svg";